export default __webpack_public_path__ + "static/media/landingimage.135817c4.png";